export default __webpack_public_path__ + "static/media/Bygone Illusion.709fcb30.png";